import script from "./GlobalLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&setup=true&lang=js"

import "./GlobalLoader.vue?vue&type=style&index=0&id=0f35a5bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f35a5bb"]])

export default __exports__